import axios from 'axios';

axios.interceptors.response.use(
  response => response,
  error => {
    return Promise.resolve(error.response);
  }
);

export default axios;
